import { fromPromise, setup } from 'xstate'

export type RegisterUserMachineEvents =
    | { type: 'NEXT' }
    | { type: 'PREVIOUS' }
    | { type: 'RETRY' }
    | { type: 'ERROR_USER_ALREADY_EXISTS' }

export type RegisterUserMachineStates = {
    value:
        | 'general'
        | 'personal'
        | 'processing'
        | 'success'
        | 'error'
        | 'errorUserAlreadyExists'
}

export const registerUserMachine = setup({
    types: {
        events: {} as RegisterUserMachineEvents,
    },
    actors: {
        register: fromPromise<void, void>(async () => {}),
    },
}).createMachine({
    id: 'register',
    initial: 'general',
    on: {
        RETRY: {
            target: '.general',
        },
    },
    states: {
        general: {
            on: {
                NEXT: 'personal',
            },
        },
        personal: {
            on: {
                PREVIOUS: 'general',
                NEXT: 'processing',
            },
        },
        processing: {
            on: {
                ERROR_USER_ALREADY_EXISTS: 'errorUserAlreadyExists',
            },
            invoke: {
                src: 'register',
                onDone: 'success',
                onError: 'error',
            },
        },
        success: {
            type: 'final',
        },
        error: {},
        errorUserAlreadyExists: {},
    },
})
